module.exports = __webpack_public_path__ + "static/media/hrapprova-white-footer-removebg.dfd9b4a4.png";